import CrudPage from "@/components/admin/CrudPage";

const FIELDS = [
  { key: "title", label: "Title" },
  { key: "category", label: "Category" },
  { key: "price_range", label: "Price range" },
  { key: "description", label: "Description", type: "textarea", rows: 2, span: "full" },
  { key: "disclaimer", label: "Disclaimer", type: "textarea", rows: 2, span: "full" },
  { key: "active", label: "Active", type: "checkbox" },
  { key: "sort_order", label: "Sort order", type: "number" },
];

const BLANK = {
  title: "", category: "general", price_range: "", description: "",
  disclaimer: "", active: true, sort_order: 99,
};

export default function AdminPricing() {
  return (
    <CrudPage
      resource="pricing"
      title="Pricing Items"
      description="Edit move-in/move-out ranges and any other pricing rows shown on the Pricing page."
      fields={FIELDS}
      blank={BLANK}
      testIdPrefix="pricing"
    />
  );
}
